import { z } from 'zod';

/**
 * Self-hosted OTA web-bundle update check (M5). The native app asks whether a
 * newer JS/HTML bundle is available for its exact native build; the server
 * answers from a deploy-stamped manifest. The bundle itself is fetched (and
 * SHA-256 verified) by the Capgo updater over HTTPS — battalion data is never
 * involved; this is just app code.
 */
export const otaCheckQuerySchema = z.object({
  // The bundle version currently running (OTA version, or the native
  // versionName on a fresh install).
  currentVersion: z.string().min(1).max(100),
  // The native versionCode — the bundle is gated to the build it was made for.
  nativeBuild: z.string().min(1).max(20),
});
export type OtaCheckQuery = z.infer<typeof otaCheckQuerySchema>;

export interface OtaCheckResponse {
  updateAvailable: boolean;
  /** The new bundle version (absent when no update). */
  version?: string;
  /** HTTPS URL of the bundle zip (absent when no update). */
  url?: string;
  /** SHA-256 hex of the zip, verified by the updater after download. */
  checksum?: string;
}
